import * as React from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';

import { IPopupItem } from 'models';

import { Popup } from '.';

interface CrystalButtonPopupProps {
  items: Array<IPopupItem>;
  popupWidth?: number;
  label?: string;
}

export const CrystalButtonPopup: React.FC<CrystalButtonPopupProps> = (props) => {
  const { items, popupWidth, label = '' } = props;

  return (
    <Popup items={items} width={popupWidth}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
        }}
      >
        {label && (
          <Typography
            color="primary"
            variant="body2"
            sx={{
              marginRight: 2,
            }}
          >
            {label}
          </Typography>
        )}

        <ButtonBase>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: `linear-gradient(-45deg, rgba(255,137,0,1) 0%, rgba(255,137,0,1) 50%, rgba(255,169,34,1) 50%, rgba(255,169,34,1) 100%)`,
              width: 30,
              height: 30,
              borderRadius: 0.5,
            }}
          >
            <Add
              sx={{
                color: 'white',
              }}
            />
          </Box>
        </ButtonBase>
      </Box>
    </Popup>
  );
};
